const getRoleId = () => {
    return localStorage.getItem('Role_id');
}


const EmployeeMappingURLs = (name,items) => {
    switch (name) {
      case 'GET_EMPLOYEEMAPPING_DATA':  {
        return `/api/usp/AgentMappings?Agent=${items.email}`;
      }
      case 'GET_EMPLOYEEMAPPING_ROLES':  {
        return `/api/usp/AgentMappingRoles`;
      }
      case 'GET_EMPLOYEEMAPPING_ACCOUNTS':  {
        return `/api/usp/AgentMappingGetAccounts?RoleId=${getRoleId()}`;
      }
      case 'GET_EMPLOYEEMAPPING_SITES':  {
        return `/api/usp/AgentMappingGetServicedesk?RoleId=${getRoleId()}`;
      }
      case 'UPDATE_USERMEMBERSHIP_DATA':  {
        return `/api/usp/AgentMappings`;
      } 
      case 'UPDATE_USERMEMBERSHIP_DELETE':  {
        return `/api/usp/UserMembershipDelete`;
      }      
      
      default: {}
    }
  }
  export default EmployeeMappingURLs;


 